export default "__VITE_ASSET__LU3$ogBi__"